import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

// Components.
import Filter from '../filter';

// Config.
import {
  FILTER_ACTIVE_SHAPE,
  FILTER_SHAPE,
} from '../../../config/prop-types';

// Images.
import iconClose from '../../images/icon-close.png';
import iconSearch from '../../images/icon-search.png';

// Services.
import getSelected from '../../js/services/filters/get-selected';
import removeActiveFilter from '../../js/services/filters/remove-active-filter';
import syncActiveFilters from '../../js/services/filters/sync-active-filters';
import updateActiveFilter from '../../js/services/filters/update-active-filter';

// Styles.
import './filters.scss';

const Filters = ({
  activeFilters,
  enableKeywordSearch,
  enableResetButton,
  enableSeeMoreButton,
  filters,
  initialOpen,
  onChange,
}) => {
  // Try to get the keyword value.
  const keywordFilter = activeFilters.find(({ type }) => 'keyword' === type);
  const keywords = keywordFilter ? keywordFilter.value : '';

  // create a custom sort order per client request
  // duplicate-ish labels because they're different in different filter uses
  const ordering = {};
  const sortOrder = [
    'years',
    'year',
    'content type',
    'content-type',
    'content-types',
    'program-areas',
    'programs',
    'topics',
    'topic',
    'communities',
    'community',
  ];
  for (let i = 0; i < sortOrder.length; i ++) { // eslint-disable-line no-plusplus
    ordering[sortOrder[i]] = i;
  }

  /**
   * Function for setting the keyword value.
   * @param {Event} event - The change event.
   */
  const setKeywords = (event) => {
    if ('' === event.target.value) {
      onChange(removeActiveFilter(activeFilters, 'keyword', keywords));
    } else if (! activeFilters.find(({ type }) => 'keyword' === type)) {
      onChange([
        ...activeFilters,
        {
          type: 'keyword',
          value: event.target.value,
        },
      ]);
    } else {
      onChange(updateActiveFilter(
        activeFilters,
        'keyword',
        keywords,
        event.target.value
      ));
    }
  };

  return (
    <form className="knight-filters">
      <fieldset
        className={classnames(
          'knight-filters__input-wrapper',
          'knight-filters__input-wrapper--fieldset'
        )}
      >
        <legend className="knight-filters__filter-heading">Filters</legend>
        {enableResetButton ? (
          <button
            className={classnames(
              'knight-filters-filters__button',
              'knight-filters-filters__button--type--reset'
            )}
            disabled={0 === activeFilters.length}
            onClick={() => onChange([])}
          >
            Reset
            <span
              className={classnames(
                'knight-filters__icon',
                'knight-filters-filters__icon',
              )}
            >
              <img src={iconClose} alt="" />
            </span>
          </button>
        ) : null}
        {enableKeywordSearch ? (
          <div
            className={classnames(
              'knight-filters__input-wrapper',
              'knight-filters__text-input-wrapper'
            )}
          >
            <label htmlFor="knight-filters-keyword">
              <span className="screen-reader-text">Keywords</span>
              <input
                className="knight-filters__text-input"
                onChange={setKeywords}
                placeholder="Keywords"
                type="text"
                value={keywords}
              />
            </label>
            <button
              className={classnames(
                'knight-filters__icon',
                'knight-filters-filters__icon',
              )}
              type="submit"
            >
              <img src={iconSearch} alt="Search for keyword" />
            </button>
          </div>
        ) : null}
        {filters
          .sort((aa, bb) => ordering[aa.type] - ordering[bb.type])
          .map(({ label, options, type }) => (
            <Filter
              enableSeeMoreButton={enableSeeMoreButton}
              initialOpen={initialOpen}
              key={type}
              label={label}
              onChange={(values) => onChange(syncActiveFilters(
                activeFilters,
                type,
                values,
              ))}
              options={options}
              selected={getSelected(activeFilters, type)}
            />
          ))
        }
      </fieldset>
    </form>
  );
};

Filters.defaultProps = {
  enableKeywordSearch: false,
  enableResetButton: false,
  enableSeeMoreButton: false,
  initialOpen: false,
};

Filters.propTypes = {
  activeFilters: PropTypes.arrayOf(PropTypes.shape(FILTER_ACTIVE_SHAPE))
    .isRequired,
  enableKeywordSearch: PropTypes.bool,
  enableResetButton: PropTypes.bool,
  enableSeeMoreButton: PropTypes.bool,
  filters: PropTypes.arrayOf(PropTypes.shape(FILTER_SHAPE)).isRequired,
  initialOpen: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default Filters;
